export enum UserStatus {
	ADDED = 'ADDED',
	INVITED = 'INVITED',
	REGISTERED = 'REGISTERED',
}
